import { render, staticRenderFns } from "./SaleReturnInvoice.vue?vue&type=template&id=b3cbb5cc&scoped=true&"
import script from "./SaleReturnInvoice.vue?vue&type=script&lang=js&"
export * from "./SaleReturnInvoice.vue?vue&type=script&lang=js&"
import style0 from "./SaleReturnInvoice.vue?vue&type=style&index=0&id=b3cbb5cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cbb5cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
